import { IOpChangeState, IJsonSerializable } from "../util/interfaces"
import { Enums } from "../common"

export class OpOperatorGroupOperator implements IOpChangeState {

    // #region

    public idOperatorGroupOperator: number
    public idOperatorGroup: number
    public idOperator: number

    // #endregion


    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IJsonSerializable

    public toJSON(compressed: boolean) {
        return {
            ID_OPERATOR_GROUP_OPERATOR: this.idOperatorGroupOperator,
            ID_OPERATOR_GROUP: this.idOperatorGroup,
            ID_OPERATOR: this.idOperator,
            OpState: this.opState
        }

    }

    public fromJSON(opObj: any) {
        this.idOperatorGroupOperator = opObj.ID_OPERATOR_GROUP_OPERATOR
        this.idOperatorGroup = opObj.ID_OPERATOR_GROUP
        this.idOperator = opObj.ID_OPERATOR
        this.opState = opObj.OpState
    }

    // #endregion

}